import { ANALYTICS_SUCCESS, ANALYTICS_LOADING, ANALYTICS_ERROR, ANALYTICS_CANCEL } from '../actions';

import set from 'lodash/set';

const analyticsReducer = (previousState = {}, action) => {
  let new_state = {...previousState};
  switch (action.type) {
    case ANALYTICS_SUCCESS:
      set(new_state, `${action.reportType}.${action.id}`, {
        loading:  false,
        report: action.report
      });
      return new_state;
    case ANALYTICS_LOADING:
      set(new_state, `${action.reportType}.${action.id}`, {
        loading: true
      })
      return new_state;
    case ANALYTICS_ERROR:
    case ANALYTICS_CANCEL:
      set(new_state, `${action.reportType}.${action.id}`, {
        loading: true
      })
    default:
      return previousState;
  }
};

export default analyticsReducer;